import { Clock, MapPin } from "lucide-react";
import { BRAND } from "@/lib/site";
import { Reveal, SectionHeading } from "./Reveal";
import { DarkMap } from "./DarkMap";

const hours = [
  ["Monday – Friday", "5:30 am – 9:30 pm"],
  ["Saturday", "9:00 am – 7:00 pm"],
  ["Sunday", "6:00 am – 9:00 pm"],
];

const LocationSection = () => {
  return (
    <section id="location" data-testid="location-section" className="py-24 md:py-32 bg-coal border-y border-line/60">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-6">
          <SectionHeading
            overline="Location & hours"
            title={
              <>
                West Perth. <em className="italic text-ember">Early to late.</em>
              </>
            }
          />
          <Reveal delay={0.1}>
            <div className="mt-10 flex items-start gap-3">
              <MapPin className="mt-1 h-5 w-5 shrink-0 text-ember" aria-hidden="true" />
              <div>
                <p data-testid="location-address" className="text-lg text-cream">{BRAND.address}</p>
                <p className="mt-1 text-sm font-light text-stone2">
                  Operating at {BRAND.parent}, two minutes from the city.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-10 border border-line">
              <div className="flex items-center gap-2 border-b border-line bg-ink px-6 py-4">
                <Clock className="h-4 w-4 text-ember" aria-hidden="true" />
                <p className="text-xs tracking-[0.2em] uppercase font-medium text-stone2">
                  Session hours
                </p>
              </div>
              <dl data-testid="location-hours" className="divide-y divide-line/60">
                {hours.map(([day, time]) => (
                  <div key={day} className="flex items-center justify-between px-6 py-4">
                    <dt className="text-sm text-sand">{day}</dt>
                    <dd className="text-sm font-medium text-cream">{time}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <p data-testid="location-saturday-note" className="mt-6 text-sm font-light leading-relaxed text-stone2">
              Weekdays: first session starts 5:30 am, last starts 8:30 pm.
              Saturdays: free {BRAND.parent} sessions run 9:00 am – 12:00 pm, with
              paid private sessions starting from 12:00 pm (last start 6:00 pm).
              Sundays: first start 6:00 am, last start 8:00 pm. The live booking
              calendar always shows exact availability.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="lg:col-span-6">
          <DarkMap />
        </Reveal>
      </div>
    </section>
  );
};

export default LocationSection;
